import { MARQUEE_ITEMS } from "@/data/site";

function Row({ hidden = false }) {
  return (
    <div className="flex shrink-0 items-center" aria-hidden={hidden}>
      {MARQUEE_ITEMS.map((item) => (
        <span key={item} className="flex items-center whitespace-nowrap">
          <span className="font-display text-2xl italic text-white/90 sm:text-3xl">{item}</span>
          <svg viewBox="0 0 24 24" className="mx-8 h-4 w-4 text-blush" fill="currentColor" aria-hidden="true">
            <path d="M12 2c.6 6 4 9.4 10 10-6 .6-9.4 4-10 10-.6-6-4-9.4-10-10 6-.6 9.4-4 10-10Z" />
          </svg>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section data-testid="marquee-band" className="marquee-paused overflow-hidden bg-lav-deep py-6">
      <div className="flex w-max animate-marquee">
        <Row />
        <Row hidden />
      </div>
    </section>
  );
}
